export function parserMetadatasFilter(filter: any) {
  const formatedFilter = { ...filter }

  return formatedFilter
}
